/* pringbud-boys-menu-click-guard */

(function () {
  var target = '/collections/boys-thobes';

  function isMuslimBoysLink(anchor) {
    if (!anchor || anchor.textContent.trim().toLowerCase() !== 'boys') return false;

    var node = anchor;
    while (node && node !== document.body) {
      var text = (node.innerText || '').toLowerCase();
      if (text.indexOf('muslim clothing') !== -1 && text.indexOf('jumper/sweater') === -1) {
        return true;
      }
      node = node.parentElement;
    }

    var exactBoys = Array.prototype.filter.call(document.querySelectorAll('a'), function (link) {
      return link.textContent.trim().toLowerCase() === 'boys';
    });
    return exactBoys[0] === anchor;
  }

  document.addEventListener('click', function (event) {
    var anchor = event.target.closest && event.target.closest('a');
    if (!isMuslimBoysLink(anchor)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    window.location.assign(target);
  }, true);
})();

